<template>
	<div class="">
		<b-row class="mb-2 d-sm-none d-md-flex">
			<b-col class="pt-1" cols="10">
				<span class="function-title">Work Order Supply Sub Contract</span>
			</b-col>
			<b-col cols="2">
				<span class="float-right">
					<b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
						:show="isCreateBusy"
						opacity="0.6"
						spinner-small
						spinner-variant="default"
						class="d-inline float-right mt-1">
						<b-button class="btn-create btn-fill-success" @click="createData" size="sm"><b-icon-plus-square class="mr-1" />Create Request</b-button>
					</b-overlay>
				</span>
			</b-col>
		</b-row>
		<div class="inbox-approval">
			<div>
				<div class="inbox-list-header">
					<div class="inbox-action-button">
						<b-row class="ml-2 mr-2">
							<b-col cols="12" md="2" class="pr-0 pl-0 inbox-header-left" v-if="isHideCheckAllData">
								<b-row class="mr-md-0 ml-md-0">
									<b-col cols="10" md="12" class="pr-0 pr-md-0 pl-md-0 combo-my-inbox">
										<app-input-combobox :options="inboxTypes" optionsLabel="label" optionsKey="value" label-cols-sm="4" label-cols-lg="3" :model.sync="inboxType" class="input-inbox-type" size="sm" :nolabel="true" :selected="inboxTypeSelected" id="input-inbox-type" @change="getInboxData" />
									</b-col>
									<b-col cols="2" class="d-md-none d-sm-block">
										<b-button class="btn-action pt-2" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search></b-button>
									</b-col>
								</b-row>
							</b-col>
							<b-col cols="12" md="10" class="inbox-header-right pr-0 d-sm-flex d-md-block" v-if="isShowCheckAllData">
								<b-button class="float-left btn-action pt-055 d-sm-none d-md-inline" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> Advance Filter</b-button>
								<app-button-approval class="float-left pt-04" :disabled="checkAllData.length > 0 ? false : true" approvalType="Approve" @approvalMethod="approveInbox" :remarks.sync="remarks" :isBusy="isApprovalBusy" icon="check-circle" />
								<app-button-approval class="float-left pt-04" :disabled="checkAllData.length > 0 ? false : true" approvalType="Reject" @approvalMethod="rejectInbox" :remarks.sync="remarks" :isBusy="isApprovalBusy" icon="x-circle" />
								<app-button-approval class="float-left pt-04" :disabled="checkAllData.length > 0 ? false : true" approvalType="Revise" @approvalMethod="reviseInbox" :remarks.sync="remarks" :isBusy="isApprovalBusy" icon="filter-circle" />
								<b-button v-if="selectedModel != null" size="sm" class="btn-default ml-1 pt-044 float-right d-sm-none d-md-inline" @click="selectedModel = null;inboxDataBusy = false">
									<b-icon-x class="mr-1"></b-icon-x>Close
								</b-button>
								<span v-if="selectedModel != null" class="d-sm-none d-md-inline">
									<b-button v-if="selectedModel.statusId == 'APPROVED' || selectedModel.statusId == 'REJECTED' || selectedModel.statusId == 'CANCELED' || selectedModel.statusId == 'WAITING FOR APPROVAL' || selectedModel.statusId == 'REQUEST FOR REVISION'" class="btn-default float-right mb-2 mr-0" @click="showApprovalFlow" v-b-tooltip.hover title="Approval History"><b-icon icon="clock-history" /></b-button>
									<b-overlay
										:show="false"
										opacity="0.6"
										spinner-small
										spinner-variant="default"
										class="d-inline float-right">
											<b-button 
												v-if="false"
												class="btn-default float-right mb-2 mr-0"
												@click="printSingleData"
												:disabled="isPdfBusy"
												v-b-tooltip.hover
												title="Print">
												<b-icon icon="printer" />
											</b-button>
									</b-overlay>
								</span>
							</b-col>
						</b-row>
					</div>
				</div>
				<div class="overflow-hidden">
					<b-row>
						<div class="inbox-list col-12 col-md-2 pr-0 inbox-list-container">
							<div v-if="isDataLoading">
								<div :id="'inbox-item-' + index" class="inbox-item pl-3 pr-3 pt-3 pb-3" v-for="index in 5" :key="index">
									<b-skeleton animation="wave" width="85%"></b-skeleton>
									<b-skeleton animation="wave" width="55%"></b-skeleton>
									<b-skeleton animation="wave" width="70%"></b-skeleton>
								</div>
							</div>
							<div v-else-if="workOrderSupplySubContracts != null && workOrderSupplySubContracts.length > 0">
								<div :id="'inbox-item-' + index" :class="'inbox-item  pl-4 pr-3 pt-0 pb-0' + (isItemInboxActive(item) ? ' inbox-active' : '')" v-for="(item, index) in workOrderSupplySubContracts" :key="index">
									<b-row>
										<b-col cols="2" class="border-right pt-1 pb-1 p-0 inbox-item-left">
											<div class="d-flex justify-content-center ml-2 h-50 border-bottom" @click="toggleIsChecked(Number(item.id))">
												<b-form-checkbox class="mt-1" v-if="(item.statusId == 'WAITING FOR APPROVAL' || item.statusId == 'REQUEST FOR REVISION') && inboxType == 'INBOX'" :id="'input-checkbox-' + (index + 1)" @change="toggleIsChecked(Number(item.id))" :checked="checkAllData.includes(Number(item.id))"></b-form-checkbox>
											</div>
											<div class="d-flex justify-content-center h-50 pt-3" @click="selectedModel = item">
												<b-avatar v-if="item.status != null" v-b-tooltip.hover :title="(item.status != null ? item.status.name : '-')" :class="'badge-status-' + (item.status != null ? item.status.initial.toLowerCase() : '-')" :text="item.status != null ? item.status.initial : '-'"></b-avatar>
											</div>
										</b-col>
										<b-col class="pl-2 pt-1 pb-1 inbox-item-right" @click="selectedModel = item">
											<div :class="selectedModel != null ? (selectedModel.id == item.id ? 'inbox-item-title active' : 'inbox-item-title active') : 'inbox-item-title active'">
												{{ item.materialIssueNumber }}
											</div>
											<div class="inbox-item-content">
												<b-row>
													<b-col>
														{{ item.materialIssueDate | moment("DD-MMM-YYYY") }}
													</b-col>
												</b-row>
												<b-row>
													<b-col>
														<app-long-text class="inbox-text" :id="'Vendor-' + index" :maxLength="10" :text="(item.vendor) ? item.vendor.code : ''" />
													</b-col>
												</b-row>
											</div>
										</b-col>
									</b-row>
								</div>
								<div class="container my-3">
									<div class="col-md-12 text-center" v-if="(workOrderSupplySubContractsPaging != null ? workOrderSupplySubContractsPaging.pageCount : 0) > currentPage">
										<b-button class="btn-default" @click="loadNextInboxPage" size="sm">Load more data</b-button>
									</div>
								</div>
							</div>
							<div v-else class="inbox-item pl-3 pr-3 pt-3 pb-3">
								<div class="" style="text-align: center">No conversations</div>
							</div>
						</div>
						<div :class="selectedModel == null ? 'inbox-content col-10 pl-0 pr-3 inbox-list-container bg-white d-sm-none d-md-block' : 'inbox-content col-10 pl-0 pr-3 inbox-list-container bg-grey d-sm-none d-md-block'">
							<div v-if="selectedModel == null">
								<app-no-data-image width="100%" />
							</div>
							<div v-else-if="selectedModel.statusId != null && selectedModel.statusId != '' && selectedModel.statusId != undefined">
								<page-inbox-base :label="title" :isShow="selectedModel.statusId != null && selectedModel.statusId != '' && selectedModel.statusId != undefined" @resetModal="selectedModel = null;inboxDataBusy = false">
									<b-card class="mt-0 mb-0 ml-auto mr-auto card-detail" body-class="p-0">
										<div v-if="selectedModel.statusId == 'WAITING FOR APPROVAL' && inboxType == 'INBOX'">
											<InputInboxApproval :inboxType="inboxType" @approvalFlow="showApprovalFlow" @closePage="selectedModel = null;inboxDataBusy = false" :selectedModelId="selectedModel.id" @change="toggleInboxDataBusy()" class="mt-3 mr-3 ml-3 mb-3" @inboxDataBusy="toggleInboxDataBusy" @successAction="successAction" />
										</div>
										<div v-else-if="selectedModel.statusId == 'REQUEST FOR REVISION'">
											<InputInboxNeedRevision :inboxType="inboxType" @approvalFlow="showApprovalFlow" @closePage="selectedModel = null;inboxDataBusy = false" :selectedModelId="selectedModel.id" @change="toggleInboxDataBusy()" class="mt-3 mr-3 ml-3 mb-3" @inboxDataBusy="toggleInboxDataBusy" @successAction="successAction" />
										</div>
										<div v-else-if="selectedModel.statusId == 'DRAFT'">
											<InputInboxDraft @closePage="selectedModel = null;inboxDataBusy = false" :selectedModelId="selectedModel.id" @change="toggleInboxDataBusy()" class="mt-3 mr-3 ml-3 mb-3" @inboxDataBusy="toggleInboxDataBusy" @successAction="successAction" />
										</div>
										<div v-else>
											<InputInboxSubmission @approvalFlow="showApprovalFlow" @closePage="selectedModel = null;inboxDataBusy = false" :selectedModelId="selectedModel.id" @change="toggleInboxDataBusy()" class="mt-3 mr-3 ml-3 mb-3" @inboxDataBusy="toggleInboxDataBusy" @successAction="successAction" />
										</div>
									</b-card>
								</page-inbox-base>
								<div class="inbox-list-footer d-md-block d-sm-none" v-if="showInboxFooter">
									<PortalTarget class="float-right d-flex mt-04 mr-3" name="app-inbox-button" />
								</div>
							</div>
							<div v-else>
								<app-no-data-image width="100%" />
							</div>
						</div>
					</b-row>
				</div>
				<Portal to="app-navbar-bottom">
					<span class="float-right">
						<b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
								:show="isCreateBusy"
								opacity="0.6"
								spinner-small
								spinner-variant="default"
								class="d-inline float-right mt-1">
							<b-button class="btn-create btn-fill-success" @click="createData" size="sm"><b-icon-plus-square class="mr-1" />Create Request</b-button>
						</b-overlay>
					</span>
				</Portal>
			</div>
		</div>
		<RouterView />
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow" 
			:dialog-class="''"
			:ok-title="'Search'"
			ok-variant="success" 
			:cancel-title="'Clear'" 
			@ok="getInboxData"
			@hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-material-issue-number" label-cols-sm="4" label-cols-lg="3" label="Material Issue Number" label-for="filter-material-issue-number" size="sm" :model.sync="filter.materialIssueNumber" />
					<app-input-combobox-autocomplete :options="purchaseOrders" optionsLabel="purchaseOrderNumber" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Subcontract Purchase Order" id="filter-" size="sm" :model.sync="filter.purchaseOrderId" @input="getPurchaseOrders" @focus="getPurchaseOrders" />
					<app-input-datepicker-range  id="fieldset-material-issue-date" label-cols-sm="4" label-cols-lg="3" label="Material Issue Date" size="sm" :modelFrom.sync="filter.materialIssueDateFrom" :modelTo.sync="filter.materialIssueDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					<app-input-textbox id="fieldset-revisi" label-cols-sm="4" label-cols-lg="3" label="Revisi" label-for="filter-revisi" size="sm" :model.sync="filter.revisi" />
					</b-col>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="wosForSubcontractStatuss" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Work Order Supply Subcont Status" id="filter-" size="sm" :model.sync="filter.wosSubcontStatusId" @input="getWosForSubcontractStatuss" @focus="getWosForSubcontractStatuss" />
					<app-input-combobox-autocomplete :options="vendors" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Vendor" id="filter-" size="sm" :model.sync="filter.vendorId" @input="getVendors" @focus="getVendors" />
					<app-input-textarea id="fieldset-remarks" label-cols-sm="4" label-cols-lg="3" label="Remarks" label-for="filter-remarks" size="sm" :model.sync="filter.remarksMultiple" />

					<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
					<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getInboxData"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
				Clear
			</b-button>
			<b-overlay
				:show="isDataLoading"
				rounded
				opacity="0.6"
				spinner-small
				spinner-variant="primary"
				class="float-right "
				>
				<b-button size="sm" class="float-right btn-default" @click="ok()">
					Search
				</b-button>
			</b-overlay>
			</template>
		</b-modal>
		<PopupApprovalHistory label="Approval History" :openPopup="isShowApprovalHistory" @resetModalMethod="resetModal" :approvalInstanceId="approvalHistoryId" />
		<PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
	</div>
</template>
<script>
import WorkOrderSupplySubContractDetail from '@/models/WorkOrderSupplySubContract/WorkOrderSupplySubContractDetail';
import WorkOrderSupplySubContractDetailFilter from '@/filters/WorkOrderSupplySubContract/WorkOrderSupplySubContractDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import PartMappingSubcontract from '@/models/PartMappingSubcontract/PartMappingSubcontract';
import PartMappingSubcontractFilter from '@/filters/PartMappingSubcontract/PartMappingSubcontractFilter';
import PurchaseOrder from '@/models/PurchaseOrder/PurchaseOrder';
import PurchaseOrderFilter from '@/filters/PurchaseOrder/PurchaseOrderFilter';
import WosForSubcontractStatus from '@/models/WosForSubcontractStatus/WosForSubcontractStatus';
import WosForSubcontractStatusFilter from '@/filters/WosForSubcontractStatus/WosForSubcontractStatusFilter';
import Vendor from '@/models/Vendor/Vendor';
import VendorFilter from '@/filters/Vendor/VendorFilter';

import WorkOrderSupplySubContract from '@/models/WorkOrderSupplySubContract/WorkOrderSupplySubContract';
import WorkOrderSupplySubContractList from '@/models/WorkOrderSupplySubContract/WorkOrderSupplySubContractList';
import WorkOrderSupplySubContractFilter from '@/filters/WorkOrderSupplySubContract/WorkOrderSupplySubContractFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppLabel from '@/components/AppLabel';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputTimepicker from '@/components/AppInputTimepicker';
import AppInputTimepickerRange from '@/components/AppInputTimepickerRange';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';
import AppButtonApproval from '@/components/AppButtonApproval';
import AppInputCombobox from '@/components/AppInputCombobox';
import InputInboxApproval from './InputInboxApproval';
import InputInboxNeedRevision from './InputInboxNeedRevision';
import InputInboxSubmission from './InputInboxSubmission';
import InputInboxDraft from './InputInboxDraft';
import PopupApprovalHistory from '@/components/PopupApprovalHistory.vue';
import PageInboxBase from '@/components/PageInboxBase.vue';

export default {
	components : {
		WorkOrderSupplySubContract,
		WorkOrderSupplySubContractList,
		WorkOrderSupplySubContractFilter,
		AppLabel,
		AppInputTextbox,
		AppInputTextarea,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTimepicker,
		AppInputTimepickerRange,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputComboboxAutocomplete,
		PopupDownload,
		PopupPDF,
		PopupDataEditNotification,
		Upload,
		AppButtonApproval,
		AppInputCombobox,
		InputInboxApproval,
		InputInboxNeedRevision,
		InputInboxSubmission,
		InputInboxDraft,
		PopupApprovalHistory,
		PageInboxBase,
	},
	data() {
		return {
			title: 'Work Order Supply Sub Contract',
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			inboxTypes: [
				{ value : 'INBOX', label : 'My Inbox', selected:true },
				{ value : 'SUBMISSION', label : 'My Submission' },
				{ value : 'FINISHEDSUBMISSION', label : 'My Finished Submission'},
				{ value : 'DRAFT', label : 'Draft' },
				{ value : "REQUESTEDDATA", label: "Requested Data" },
			],
			inboxType: 'INBOX',
			inboxTypeSelected: 'My Inbox',
			perPage: 10,
			currentPage: 1,
			totalData:0,
			busy:false,
			isDataLoading: false,
			isMultiplePrintBusy: false,
			isShowApprovalHistory: false,
			approvalHistoryId: 0,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			workOrderSupplySubContracts: [],
			workOrderSupplySubContractsPaging: {},
			isFilterShow: false,
			isDeleteBusy: false,
			selectedModel: null,
			inboxDataBusy: false,
			isApprovalBusy: false,
			remarks: "",
			popoverShow: false,
			approvalType: "",
			windowWidth: 0,
			isShowPopupPDF: false,
			isPdfBusy: false,
			pdfUrl: '',
		workOrderSupplySubContractDetails: [],
		parts: [],
		partMappingSubcontracts: [],
		purchaseOrders: [],
		wosForSubcontractStatuss: [],
		vendors: [],

		}
	},	
	methods : {
		getInboxData() {
			this.currentPage = 1;
			this.workOrderSupplySubContracts = [];
			if (this.inboxType == "INBOX") {
				this.filter["notStatusId"] = null;
				this.filter["statusId"] = "WAITING FOR APPROVAL,REQUEST FOR REVISION";
				return this.getWorkOrderSupplySubContractInboxes();
			}
			else if (this.inboxType == "SUBMISSION") {
				this.filter["statusId"] = null;
				this.filter["notStatusId"] = "APPROVED,REJECTED,CANCELED,DRAFT";
				this.filter["statusNotEmpty"] = true;
				this.getWorkOrderSupplySubContractSubmissions();
			} 
			else if (this.inboxType == "FINISHEDSUBMISSION") {
				this.filter["notStatusId"] = null;
				this.filter["statusId"] = "APPROVED,REJECTED,CANCELED";
				this.getWorkOrderSupplySubContractSubmissions();
			}
			else if (this.inboxType == "DRAFT") {
				this.filter["notStatusId"] = null;
				this.filter["statusId"] = "DRAFT";
				this.getWorkOrderSupplySubContractDraft();
			}
			else if (this.inboxType == "REQUESTEDDATA") {
				this.filter["notStatusId"] = null;
				this.filter["statusId"] = null;
				this.filter["statusNotEmpty"] = true;
				this.getWorkOrderSupplySubContractRequestedData();
			}
		},
		loadNextInboxPage() {
			this.currentPage++;
			if (this.inboxType == "INBOX") {
				this.getWorkOrderSupplySubContractInboxes();
			}
			else if (this.inboxType == "SUBMISSION") {
				this.getWorkOrderSupplySubContractSubmissions();
			} 
			else if (this.inboxType == "FINISHEDSUBMISSION") {
				this.getWorkOrderSupplySubContractSubmissions();
			}
			else if (this.inboxType == "DRAFT") {
				this.getWorkOrderSupplySubContractDraft();
			}
			else if (this.inboxType == "REQUESTEDDATA") {
				this.getWorkOrderSupplySubContractRequestedData();
			}
		},
		getWorkOrderSupplySubContractInboxes : async function() {
			this.selectedModel = null;
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			return WorkOrderSupplySubContract.getMyApprovalList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					// this.workOrderSupplySubContracts = result.data
					result.data.forEach(item => {
						this.workOrderSupplySubContracts.push(item);
					});
					this.workOrderSupplySubContractsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getWorkOrderSupplySubContractRequestedData : async function() {
			this.selectedModel = null;
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			WorkOrderSupplySubContract.getRequestedDataList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
				result.data.forEach(item => {
					this.workOrderSupplySubContracts.push(item);
				});
				this.workOrderSupplySubContractsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getWorkOrderSupplySubContractSubmissions : async function() {
			this.selectedModel = null;
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			WorkOrderSupplySubContract.getMySubmissionList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					// this.workOrderSupplySubContracts = result.data
					result.data.forEach(item => {
						this.workOrderSupplySubContracts.push(item);
					});
					this.workOrderSupplySubContractsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getWorkOrderSupplySubContractDraft : async function() {
			this.selectedModel = null;
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			WorkOrderSupplySubContract.getMySubmissionList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					// this.workOrderSupplySubContracts = result.data
					result.data.forEach(item => {
						this.workOrderSupplySubContracts.push(item);
					});
					this.workOrderSupplySubContractsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getWorkOrderSupplySubContractsWithoutLoading : async function() {
			this.selectedModel = null;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			if (this.inboxType == "INBOX") {
				this.filter["statusId"] = "WAITING FOR APPROVAL,REQUEST FOR REVISION";
				WorkOrderSupplySubContract.getMyApprovalList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
				.then(result => {
					if (result != null) {
						this.workOrderSupplySubContracts = result.data
						this.workOrderSupplySubContractsPaging = result
					}
				})
				.catch(error => {});
			} else if (this.inboxType == "SUBMISSION") {
				this.filter["statusId"] = "";
				WorkOrderSupplySubContract.getMySubmissionList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
				.then(result => {
					if (result != null) {
						this.workOrderSupplySubContracts = result.data
						this.workOrderSupplySubContractsPaging = result
					}
				})
				.catch(error => {});
			} else if (this.inboxType == "DRAFT") {
				this.filter["statusId"] = "DRAFT";
				WorkOrderSupplySubContract.getMySubmissionList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
				.then(result => {
					if (result != null) {
						this.workOrderSupplySubContracts = result.data
						this.workOrderSupplySubContractsPaging = result
					}
				})
				.catch(error => {});
			}
		},
		getWorkOrderSupplySubContractDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterWorkOrderSupplySubContractDetail);
			if (this.modelId == null) return;
			filter.workOrderSupplySubContractId = this.modelId;
			//filter.draftMode = "0";
			if (this.sortByWorkOrderSupplySubContractDetail != null) {
				this.sortingByWorkOrderSupplySubContractDetail[this.sortByWorkOrderSupplySubContractDetail] = this.sortDescWorkOrderSupplySubContractDetail;
			}
			let currentPage = (this.currentWorkOrderSupplySubContractDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalWorkOrderSupplySubContractDetailRow + 1;
				let page = Math.ceil(totalData/this.workOrderSupplySubContractDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.workOrderSupplySubContractDetailPageSize = 0;
			// disable paging end
			WorkOrderSupplySubContractDetail.getList(this, filter, this.sortingByWorkOrderSupplySubContractDetail, currentPage , this.workOrderSupplySubContractDetailPageSize).then(result => {
				this.currentWorkOrderSupplySubContractDetailPage = currentPage + 1;
				this.workOrderSupplySubContractDetails = result.data;
				this.totalWorkOrderSupplySubContractDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getWorkOrderSupplySubContracts : async function(input) {
			let filter = new WorkOrderSupplySubContractFilter();
			if (input != undefined) {
				filter.materialIssueNumber = input;
			}
			this.isWorkOrderSupplySubContractComboLoading = true;
			WorkOrderSupplySubContract.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderSupplySubContracts = result.data
				}
				this.isWorkOrderSupplySubContractComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getPartMappingSubcontracts : async function(input) {
			let filter = new PartMappingSubcontractFilter();
			if (input != undefined) {
				filter.part = input;
			}
			this.isPartMappingSubcontractComboLoading = true;
			PartMappingSubcontract.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partMappingSubcontracts = result.data
				}
				this.isPartMappingSubcontractComboLoading = false;
			})
			.catch(error => {});
		},
		getPurchaseOrders : async function(input) {
			let filter = new PurchaseOrderFilter();
			if (input != undefined) {
				filter.purchaseOrderNumber = input;
			}
			filter.fwDocStat = '0,1';
			filter.exactType.fwDocStat = '1';
			PurchaseOrder.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.purchaseOrders = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPurchaseOrderExecuted(item) {
			let _this = this;
			if(item == undefined || item == null) {
				this.model.purchaseOrderId = null;
				this.model.purchaseOrder = null;
				this.isBusy = true;
				WorkOrderSupplySubContract.resetDocument(this, this.model.id).then(result => {
					this.getWorkOrderSupplySubContract(this.model.id).then(result => {
						this.getWorkOrderSupplySubContractDetails();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			} else {
				this.model.purchaseOrderId = item.id;
				this.model.purchaseOrder = item;

				this.isBusy = true;
				WorkOrderSupplySubContract.copyFromDocument(this, 'purchaseorder', item.id, this.model.id).then(result => {
					this.getWorkOrderSupplySubContract(this.model.id).then(result => {
						this.getWorkOrderSupplySubContractDetails();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			}
		},
		setSelectedPurchaseOrder(item) {
			if(item) {
				var itemId = Number(item.id);
				if(this.model.purchaseOrderId == itemId) return;
			}

			if(this.workOrderSupplySubContractDetails != null && this.workOrderSupplySubContractDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap Work Order Supply Sub Contract akan me-reset form yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.setSelectedPurchaseOrderExecuted(item);
					}
				})
				.catch(err => {})
			} else {
				this.setSelectedPurchaseOrderExecuted(item);
			}
		},		onPurchaseOrderChange : async function() {
let item = this.model.purchaseOrderId;
let purchaseOrderObj = this.purchaseOrders.filter(function(purchaseOrder){ return purchaseOrder.id == item; });
this.model.purchaseOrder = purchaseOrderObj.length > 0 ? purchaseOrderObj[0] : null;
		},
		getWosForSubcontractStatuss : async function(input) {
			let filter = new WosForSubcontractStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			WosForSubcontractStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.wosForSubcontractStatuss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedWosSubcontStatus(item) {
			if(item == undefined || item == null) {
				this.model.wosSubcontStatusId = null;
				this.model.wosSubcontStatus = null;
			} else {
				this.model.wosSubcontStatusId = item.id;
				this.model.wosSubcontStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getVendors : async function(input) {
			let filter = new VendorFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Vendor.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.vendors = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedVendor(item) {
			if(item == undefined || item == null) {
				this.model.vendorId = null;
				this.model.vendor = null;
			} else {
				this.model.vendorId = item.id;
				this.model.vendor = item;
			}
			this.$forceUpdate();
			this.updateData();
		},

		resetFilter() {
			this.filter = new WorkOrderSupplySubContractFilter();
			this.getInboxData();
			this.isFilterShow = false;
		},
		resetModal() {
			this.isFilterShow = false;
		},
		toggleIsChecked(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		createData() {
			this.isCreateBusy = true;
			WorkOrderSupplySubContract.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'workordersupplysubcontractcreateinboxrequest', params : { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			WorkOrderSupplySubContract.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'workordersupplysubcontractdetailapproval', params : { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},
		toggleInboxDataBusy() {
			if (this.inboxDataBusy)
				this.inboxDataBusy = false;
			else
				this.inboxDataBusy = true;
		},
		successAction() {
			this.selectedModel = null;
			this.inboxDataBusy = false
			this.getInboxData();
		},
		approveInbox() {
			let data = this.$store.state.dataIds;
			this.popoverShow = false;
			if (data.length > 0) {
				this.isApprovalBusy = true;
				WorkOrderSupplySubContract.approveMultipleData(this, this.remarks).then(result => {
					this.isApprovalBusy = false;
					this.remarks = "";
					this.getInboxData();
				}).catch(error => {
					this.isApprovalBusy = false;	
				});
			}
		},
		rejectInbox() {
			let data = this.$store.state.dataIds;
			this.popoverShow = false;
			if (data.length > 0) {
				this.isApprovalBusy = true;
				WorkOrderSupplySubContract.rejectMultipleData(this, this.remarks).then(result => {
					this.isApprovalBusy = false;
					this.remarks = "";
					this.getInboxData();
				}).catch(error => {
					this.isApprovalBusy = false;	
				});
			}
		},
		reviseInbox() {
			let data = this.$store.state.dataIds;
			this.popoverShow = false;
			if (data.length > 0) {
				this.isApprovalBusy = true;
				WorkOrderSupplySubContract.reviseMultipleData(this, this.remarks).then(result => {
					this.isApprovalBusy = false;
					this.remarks = "";
					this.getInboxData();
				}).catch(error => {
					this.isApprovalBusy = false;	
				});
			}
		},
		resetModal() {
			this.isShowApprovalHistory = false;
			this.isShowPopupPDF = false;
		},
		showApprovalFlow() {
			if(this.selectedModel != null && this.selectedModel != undefined) {
				this.approvalHistoryId =  this.selectedModel.approvalInstanceId;
				this.isShowApprovalHistory = true;
			}
		},
		printSingleData() {
			this.isPdfBusy = true;
			if(this.selectedModel != null && this.selectedModel != undefined) {
				WorkOrderSupplySubContract.singleDataPagePrint(this, this.selectedModel.id).then(result => {
					if (result) {
						this.showPopupPDF(result.download);
					}
					this.isPdfBusy = false;
				});
			} else {
				this.isPdfBusy = false;
			}
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new WorkOrderSupplySubContractFilter();
	},
	mounted(){
		let breadcrumb = [
			"Work Order Supply Sub Contract"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.windowWidth = window.innerWidth;
		let submission = this.$route.query.submission;
		if (submission != null && submission != undefined && submission == '1') {
			this.inboxType = 'SUBMISSION';
			this.inboxTypeSelected = 'My Submission';
		}
		let inboxType = this.$route.query.type;
		if (inboxType != null && inboxType != undefined && inboxType != '') {
			this.inboxType = inboxType;
		}
		this.$nextTick(() => {
			this.getInboxData().then(result => {
				let documentId = this.$route.query.id
				let item = this.workOrderSupplySubContracts.filter(e=>e.id == documentId)
				if(item.length > 0) {
					this.selectedModel = item[0]
				}
			});
			window.addEventListener('resize', this.displayFilter);
		});
	},
	watch: {
	/*
		sortBy: {
			handler: function() {
				this.getInboxData();
			}
		},
		sortDesc: {
			handler: function() {
				this.getInboxData();
			}
		},
		currentPage: {
			handler: function() {
				this.getInboxData();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getInboxData();
			}
		},
		*/
		selectAll(newValue) {
			if (newValue) {
				WorkOrderSupplySubContract.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (from.name == "workordersupplysubcontractcreateinboxrequest") {
					// this.getWorkOrderSupplySubContractsWithoutLoading();
					this.getInboxData();
				}
			}
		},
	},
	computed: {
		isItemInboxActive: function () {
			var vm = this;
			return function (item) {
				if (vm.selectedModel != null) {	
					if (vm.selectedModel.id == item.id) return true;
				} 
				if (vm.checkAllData.length > 0) {
					if (vm.checkAllData.includes(Number(item.id))) return true;
				}
				return false;
			};
		},
		isHideCheckAllData() {
			if (this.windowWidth > 576) return true;
			return this.checkAllData.length <= 0;
		},
		isShowCheckAllData() {
			if (this.windowWidth > 576) return true;
			return this.checkAllData.length > 0;
		},
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "work_order_supply_sub_contract").first();
		},
		showInboxFooter() {
			if (this.selectedModel != null && this.selectedModel != undefined) {
				if ((this.selectedModel.statusId == 'WAITING FOR APPROVAL' && this.inboxType == "INBOX") || 
					this.selectedModel.statusId == 'DRAFT' || 
					(this.selectedModel.statusId == 'REQUEST FOR REVISION' && this.inboxType == "INBOX") ||
					this.selectedModel.statusId == 'APPROVED'
					)
					return true;
			}
			return false;
		}
	},
	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
